const STORAGE_KEY = 'unscramble_history';
const MAX_ENTRIES = 50;

export const getHistory = () => {
  try {
    const data = localStorage.getItem(STORAGE_KEY);
    return data ? JSON.parse(data) : [];
  } catch (error) {
    console.error('Failed to read history:', error);
    return [];
  }
};

export const saveToHistory = (entry) => {
  try {
    const history = getHistory();

    const newEntry = {
      id: Date.now().toString(),
      timestamp: new Date().toISOString(),
      name: `Ramble from ${formatDate(new Date())}`,
      ...entry,
    };

    // Add to beginning, limit to MAX_ENTRIES
    const updated = [newEntry, ...history].slice(0, MAX_ENTRIES);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(updated));

    return newEntry;
  } catch (error) {
    console.error('Failed to save to history:', error);
    return null;
  }
};

export const getHistoryItem = (id) => {
  const history = getHistory();
  return history.find(item => item.id === id) || null;
};

export const updateHistoryName = (id, newName) => {
  try {
    const history = getHistory();
    const updated = history.map(item =>
      item.id === id ? { ...item, name: newName } : item
    );
    localStorage.setItem(STORAGE_KEY, JSON.stringify(updated));
    return true;
  } catch (error) {
    console.error('Failed to update history name:', error);
    return false;
  }
};

export const deleteFromHistory = (id) => {
  try {
    const history = getHistory();
    const updated = history.filter(item => item.id !== id);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(updated));
    return true;
  } catch (error) {
    console.error('Failed to delete from history:', error);
    return false;
  }
};

export const clearHistory = () => {
  try {
    localStorage.removeItem(STORAGE_KEY);
    return true;
  } catch (error) {
    console.error('Failed to clear history:', error);
    return false;
  }
};

// Helper function to format date nicely
const formatDate = (date) => {
  const options = {
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    hour12: true
  };
  return date.toLocaleDateString('en-US', options);
};

// Get relative time string
export const getRelativeTime = (timestamp) => {
  const now = new Date();
  const date = new Date(timestamp);
  const diffMs = now - date;
  const diffMins = Math.floor(diffMs / 60000);
  const diffHours = Math.floor(diffMs / 3600000);
  const diffDays = Math.floor(diffMs / 86400000);

  if (diffMins < 1) return 'Just now';
  if (diffMins < 60) return `${diffMins} minute${diffMins !== 1 ? 's' : ''} ago`;
  if (diffHours < 24) return `${diffHours} hour${diffHours !== 1 ? 's' : ''} ago`;
  if (diffDays < 7) return `${diffDays} day${diffDays !== 1 ? 's' : ''} ago`;

  return formatDate(date);
};
